import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminDeleted_itemsCollection_points = z.any()
export type TagsGetAdminDeleted_itemsCollection_points = z.infer<typeof tagsGetAdminDeleted_itemsCollection_points>

export const responseGetAdminDeleted_itemsCollection_points = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "type": z.string(), "identifier": z.string(), "building": z.object({ "name": z.string() }), "municipality": z.object({ "name": z.string() }), "deletedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminDeleted_itemsCollection_points = z.infer<typeof responseGetAdminDeleted_itemsCollection_points>

interface IGetAdminDeleted_itemsCollection_points extends BaseMethodType {
  tags: TagsGetAdminDeleted_itemsCollection_points,
  response: ResponseGetAdminDeleted_itemsCollection_points
}
export const URL = '/admin/deleted-items/collection-points'
export const validation = {
  get: {
    tags: tagsGetAdminDeleted_itemsCollection_points,
    response: responseGetAdminDeleted_itemsCollection_points
  }
}
export interface AdminDeleted_itemsCollection_points extends BaseRouteType {
  get: IGetAdminDeleted_itemsCollection_points
}